import { createContext, useEffect, useState, useCallback } from "react";
import { db } from "../firebase";
import { Switch, useParams } from "react-router-dom";

export const PluginsValue = createContext({});
export const PluginsDisbatch = createContext({});

export default function PluginsContext({ children }) {
  const [plugins, setPlugins] = useState([]);
  const [data, setData] = useState({});
  const { appId } = useParams();

  useEffect(() => {
    const unsub = db
      .collection("apps")
      .doc(appId)
      .collection("plugins")
      .onSnapshot((snap) => {
        setPlugins(snap.docs.map((d) => ({ ...d.data(), id: d.id })));
      });

    return unsub;
  }, [appId]);

  useEffect(() => {
    const fetch = async () => {
      const _plugins = {};

      const promises = plugins.map(async (p) => {
        const doc = await db
          .collection("plugins")
          .doc(p.plugin)
          .collection("versions")
          .doc(p.version)
          .get();
        _plugins[p.id] = { ...p, plugin: doc.data() };
      });
      await Promise.all(promises);
      setData(_plugins);
    };

    fetch();
  }, [plugins]);

  const disbatch = useCallback(
    (value) => {
      const _data = { ...data };

      switch (value.type) {
        case "setVersion":
          db.collection("apps")
            .doc(appId)
            .collection("plugins")
            .doc(value.plugin)
            .update({ version: value.version });
        case "setConfig":
          db.collection("apps")
            .doc(appId)
            .collection("plugins")
            .doc(value.plugin)
            .update({ config: value.config });
        default:
          return _data;
      }
    },
    [appId]
  );

  return (
    <PluginsValue.Provider value={data}>
      <PluginsDisbatch.Provider value={disbatch}>
        {children}
      </PluginsDisbatch.Provider>
    </PluginsValue.Provider>
  );
}
